import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const TimeTravel = () => {
  const navigate = useNavigate();
  const [score, setScore] = useState(0);
  const [question, setQuestion] = useState(null);
  const [userAnswer, setUserAnswer] = useState('');
  const [feedback, setFeedback] = useState('');
  const [questionsAnswered, setQuestionsAnswered] = useState(0);

  const timeQuestions = [
    { question: "3 hours 30 minutes = ? minutes", answer: 210 },
    { question: "150 minutes = ? hours ? minutes", answer: "2:30" },
    { question: "2 hours 45 minutes + 1 hour 30 minutes = ?", answer: "4:15" },
    { question: "5:45 PM in 24-hour format", answer: "17:45" },
    { question: "How many minutes in 2.5 hours?", answer: 150 },
    { question: "4 hours 20 minutes - 1 hour 50 minutes = ?", answer: "2:30" },
    { question: "How many seconds in 5 minutes?", answer: 300 },
    { question: "180 seconds = ? minutes", answer: 3 },
    { question: "1 hour 15 minutes = ? minutes", answer: 75 },
    { question: "3:30 PM in 24-hour format", answer: "15:30" },
    { question: "How many hours in 240 minutes?", answer: 4 },
    { question: "2 hours 30 minutes + 45 minutes = ?", answer: "3:15" },
  ];

  const generateQuestion = () => {
    const q = timeQuestions[Math.floor(Math.random() * timeQuestions.length)];
    setQuestion(q);
    setUserAnswer('');
    setFeedback('');
  };

  useEffect(() => {
    generateQuestion();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!question) return;

    const answer = userAnswer.trim();
    const correct = answer === String(question.answer);

    if (correct) {
      setScore(score + 15);
      setQuestionsAnswered(questionsAnswered + 1);
      setFeedback('✅ Correct!');
      setTimeout(generateQuestion, 1500);
    } else {
      setFeedback(`❌ Wrong! Answer: ${question.answer}`);
      setTimeout(generateQuestion, 2500);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-500 via-purple-500 to-pink-500 py-8 px-4">
      <div className="max-w-3xl mx-auto">
        <div className="bg-white/10 backdrop-blur-md rounded-xl p-6 mb-6 text-white">
          <div className="flex justify-between items-center">
            <button onClick={() => navigate('/games')} className="hover:text-yellow-300">← Back</button>
            <h1 className="text-3xl font-bold">⏰ Time Travel</h1>
            <div className="text-2xl font-bold">{score} pts</div>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-2xl p-8">
          <div className="text-center mb-8">
            <div className="text-6xl mb-4">⏰</div>
            <h2 className="text-2xl font-bold text-gray-800">Solve Time Problems!</h2>
          </div>

          {question && (
            <div className="text-center">
              <div className="text-2xl font-bold text-indigo-600 mb-6">{question.question}</div>
              <form onSubmit={handleSubmit} className="max-w-md mx-auto">
                <input
                  type="text"
                  value={userAnswer}
                  onChange={(e) => setUserAnswer(e.target.value)}
                  className="w-full text-3xl text-center border-4 border-indigo-300 rounded-lg p-4 mb-4 focus:border-indigo-500 focus:outline-none"
                  placeholder="Your answer"
                  autoFocus
                />
                <button type="submit" className="w-full bg-indigo-600 text-white text-xl font-bold py-4 rounded-lg hover:bg-indigo-700">
                  Submit
                </button>
              </form>
              {feedback && (
                <div className={`mt-4 text-xl font-bold ${feedback.includes('✅') ? 'text-green-600' : 'text-red-600'}`}>
                  {feedback}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TimeTravel;